import { Component, Output, EventEmitter, OnInit, Input, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { zip } from 'rxjs';
import { ModalComponent } from '../../../modal/modal.component';
import { BaseModalPageComponent } from '../../../base-modal.component';
import { MachineFamillyService } from '../../../shared/services';
import { Machine } from '../../../shared/models';
import * as _ from 'lodash';

@Component({
  selector: 'machine-form',
  templateUrl: './machine-form.component.html',
  standalone: false
})
export class MachineFormComponent extends BaseModalPageComponent implements OnInit {
  @ViewChild('modelsModal', { static: true })
  modal: ModalComponent;
  @ViewChild('productLinesModal', { static: true })
  productLinesModal: ModalComponent;

  @Input() public processing;
  @Input() public machine: Machine;
  @Output() public toggleCreateMachine: EventEmitter<any> = new EventEmitter();
  @Output() public toggleCancel: EventEmitter<any> = new EventEmitter();

  public productLines: any[];
  public categories: any[];
  public machineModels: any[];

  public modelSelectorValues: any[] = [];
  public modelSelected: any;

  public productLineSelected: any;
  public productLineSelectorValues: any = [];

  public machineForm: UntypedFormGroup;

  constructor(private machineFamillyService: MachineFamillyService, location: Location) {
    super(location);
  }

  ngOnInit(): void {
    this.initForm();
    if (this.machine) {
      this.machineForm.patchValue(this.machine);
    }
    this.loadData();
  }

  initForm(): void {
    this.machineForm = new UntypedFormGroup({
      serialNumber: new UntypedFormControl(null, Validators.required),
      productLine: new UntypedFormControl(null, Validators.required),
      modelId: new UntypedFormControl(null, Validators.required),
      modelName: new UntypedFormControl(null, Validators.required),
      clientSerialNumber: new UntypedFormControl(null),
      year: new UntypedFormControl(null)
    });
  }

  loadData() {
    zip(
      this.machineFamillyService.getCurrentScopeProductLines(),
      this.machineFamillyService.getCategories(),
      this.machineFamillyService.getModels()
    ).subscribe(([lines, categories, models]) => {
      this.productLines = lines;
      this.categories = categories;
      this.machineModels = models;

      this.productLineSelectorValues = this.productLines.map((p) => ({ label: p.name, value: p.id }));
      this.productLineSelected = this.productLines.find((p) => p.id === this.machine.productLine);
      this.updateModelSelectorValues(this.productLineSelected);
      this.modelSelected = this.machineModels.find((m) => m.id === this.machine.modelId);
    });
  }

  public openModelsSelector(): void {
    this.openSelector(this.modal, this.modelSelectorValues, this.modelSelected?.id, { search: true });
  }

  public openProductLinesSelector(): void {
    this.openSelector(this.productLinesModal, this.productLineSelectorValues, this.productLineSelected?.id);
  }

  public selectModelsMenu(item: any) {
    this.modelSelected = this.machineModels.find((m) => m.id === item.selectedIndex);
    this.machineForm.controls['modelName'].setValue(this.modelSelected?.name);
    this.machineForm.controls['modelId'].setValue(this.modelSelected?.id);
  }

  public selectProductLinesMenu(item: any) {
    this.productLineSelected = this.productLines.find((p) => p.id === item.selectedIndex);
    this.machineForm.controls['productLine'].setValue(this.productLineSelected.id);
    this.updateModelSelectorValues(this.productLineSelected);
    this.machineForm.controls['modelName'].setValue('');
    this.machineForm.controls['modelId'].setValue('');
    this.modelSelected = null;
  }

  public updateModelSelectorValues(selectedProductLine: any) {
    if (selectedProductLine) {
      const productLineId = selectedProductLine.id;
      let categories = _.filter(this.categories, ['productLineId', productLineId]);
      categories = _.map(categories, 'id');
      const machinesComboData = _.filter(
        this.machineModels,
        (m: any) =>
          _.find(categories, (c: any) => {
            return c === m.categoryId;
          }) !== undefined
      );
      this.modelSelectorValues = _.map(machinesComboData, (m) => ({
        label: m.name,
        value: m.id
      })).sort((a, b) => a.label.localeCompare(b.label));
    }
  }

  public save() {
    if (this.machineForm.invalid) {
      return;
    }
    this.toggleCreateMachine.emit(this.machineForm.value);
  }

  public cancel() {
    this.toggleCancel.emit();
  }
}
